import Vue from 'vue'
import AscMenuBtn from '@/components/atoms/AscMenuBtn'

export default Vue.extend({
  components: {
    AscMenuBtn,
  },

  data: function () {
    return {}
  },

  computed: {
    iconOnly() {
      return this.params.iconOnly
    },
    getAlertCount() {
      return this.params.data.alertCount
    },
    getItems() {
      return this.params.data.ellipseOptions
    },
  },
  methods: {
    handleEllipsesSelection(arg) {
      const callbackProperties = {
        selectionKey: arg,
        selectedObject: this.params.data,
      }
      this.params.callback(callbackProperties)
    },
  },

  template: `<asc-menu-btn :iconOnly= "iconOnly" :items="getItems" @onMenuSelect="handleEllipsesSelection" />`,
})
